<template>
  <div class="page">
		<PageHeader>
			Главная
		</PageHeader>

		<div class="content">
			<h1 class="welcome">Добро пожаловать!</h1>
		</div>
  </div>
</template>

<script>
import PageHeader from "../ui/PageHeader.vue";
export default {
  components: { PageHeader },
  name: 'Main',
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Main.vue